// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { PUBLIC_RUNTIME_CONFIG } from './config/publicRuntimeConfig';

const getFirebaseConfig = () => {
  const hostname = window.location.hostname;
  const defaults = PUBLIC_RUNTIME_CONFIG.firebase;

  console.log(`Using Firebase project: ${process.env.REACT_APP_FIREBASE_PROJECT_ID || defaults.projectId} (Host: ${hostname})`);

  return {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || defaults.apiKey,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || defaults.authDomain,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || defaults.projectId,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || defaults.storageBucket,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || defaults.messagingSenderId,
    appId: process.env.REACT_APP_FIREBASE_APP_ID || defaults.appId,
  };
};

const firebaseConfig = getFirebaseConfig();
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Auth persistence set to LOCAL');
  })
  .catch((error) => {
    console.error('Error setting auth persistence:', error);
  });

console.log('Firebase Config:', { ...firebaseConfig, apiKey: 'REDACTED', appId: 'REDACTED' });

export {
  app,
  auth,
  db,
  storage,
};
